import { RecallMode } from "../../models/enums/RecallMode";
import { ActionTypes } from "../actions/types";
import { DEBUG_ENABLED, DEBUG_DISABLED, SET_RECALL_MODE } from "../actions";

export const recallModeReducer = (state, action: ActionTypes) => {
    switch (action.type) {
        case DEBUG_ENABLED:
        case DEBUG_DISABLED:
            return RecallMode.Enabled;
        case SET_RECALL_MODE:
            return action.mode;
        default:
            return state;
    }
};
